export const RUSSIAN_LOCALE = "ru";
export const ENGLISH_LOCALE = "en";

export const AgreeType = {
  creditReport: "4A3FAF70-3219-4C22-964A-837A88F024AB".toLowerCase(), // Согласие на получение кредитного отчета для ООО МКК \"Турбозайм\"
  creditReportEqvantaLab: "2B4B3E01-4CE2-4024-AA3A-A67006A6BCC0".toLowerCase(), // Согласие на получение кредитного отчета для ООО \"ЭквантаЛаб\"
  agreementPersonalDataForReviewApplication:
    "063CB91D-4B55-4466-A8BC-21B802C29635".toLowerCase(), // Согласие на обработку персональных данных с целью рассмотрения заявки
  agreementPersonalDataForDebtCollection:
    "F6066205-AD1B-40E0-B896-E1D06FC119B6".toLowerCase(), // Согласием на обработку персональных данных с целью взыскания задолженности
} as const;

export const FinancingInstrumentType = {
  PaymentCard: "d265196f-de5e-42e1-8df4-f20e54950f55", // Платёжная карта
} as const;

// урлы на которых можно открыть калькулятор по клику на кнопке (на остальных калькулятор недоступен, но кнопка есть)
export const isCalculatorAvailable = (pathname: string) => {
  const urlsWithAvailableCalc = [
    "/registration",
    "/authorization",
    "/new_application-passport",
    "/new_application-address",
    "/new_application-place-work",
    "/new_application-additional-questions",
    "/new_application-select-map",
    "/reapplication-method-obtaining",
    "/reapplication-confirmation",
  ];
  return urlsWithAvailableCalc.indexOf(pathname) >= 0;
};

const urlsWithHiddenSum = [
  "/reapplication-signing",
  "/new_application-signing",
  "/vas-payment",
];

export const isCalculatorSumAvailable = (pathname: string) =>
  urlsWithHiddenSum.indexOf(pathname) < 0;

export const UserExperiments = {
  addSum: "18ef30de-c580-42a9-943b-eac2dba8cda5",
  skipDocuments: "37a0b02c-473c-48b2-8b8c-652c02f7071e",
  preScoring: "15a96917-1098-497b-8ed9-cf79ad99fb64",
} as const;

export const ExperimentGroup = {
  A: "A", // Контрольная группа
  B: "B", // Экспериментальная группа
} as const;

export const formPageIds = {
  agreesPersonalDataAndASP: "7ef41031-57b1-4c1e-93b9-0a11b31a7a28",
  agreesCreditReport: "EBE4EC48-51D5-4104-A573-BD177572597F".toLowerCase(),
  valueAddedService: "4F1E4F12-F700-4C5F-811A-EE3CCE4D8BEE",
  reapplicationConfirmationValueAddedService:
    "79716122-CC9A-49ED-97C0-B9C90B607EB7",
} as const;

export const headerLogoLinkDisabledRoutes = [
  "/authorization-number-confirmation",
  "/registration-number-confirmation",
] as const;

export const headerLkLinkDisabledRoutes = [
  "/agreement",
  "/authorization-number-confirmation",
  "/registration-number-confirmation",
  "/authorization",
  "/registration",
];

export const appConsiderationErrorCodes = {
  financingInstrument: [124, 125, 210],
  applicationFullness: [216, 217, 209],
  scans: [211, 212],
};

export const loaderFormIds = {
  smev4FormId: "07B33038-C6AB-4687-A249-D2057DA4CF37",
  innFormId: "ACBD6F97-F885-4918-AC51-A20DA3CE089E",
  prescoringFormId: "CAEFE906-92D9-417A-B9D5-84A34F946531",
} as const;

export const REVOCATION_BKI_AGREEMENT_ID = "revocationbkiagreement";
